import React, {useState, useEffect, useRef} from 'react'
import '../css/Select.css'

const CustomSelect = ({ value, options, onChange, className, optionLabelKey = 'roleName', optionValueKey = 'roleId' }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedLabel, setSelectedLabel] = useState('')
    const selectRef = useRef(null)

    useEffect(() => {
        const selected = options.find(opt => opt[optionValueKey] === value)
        setSelectedLabel(selected ? selected[optionLabelKey] : 'Выберите...')
    }, [value, options, optionLabelKey, optionValueKey])

    // Закрываем при клике вне компонента
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const handleSelect = (optionValue) => {
        onChange(optionValue)
        setIsOpen(false)
    }

    return (
        <div className="custom-select-container" ref={selectRef}>
            <div
                className={`custom-select-header ${className}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="custom-select-header-text">{selectedLabel}</span>
                <span className={`custom-select-arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </div>
            {isOpen && (
                <div className="custom-select-options">
                    {options.map(option => (
                        <div
                            key={option[optionValueKey]}
                            className={`custom-select-option ${value === option[optionValueKey] ? 'selected' : ''}`}
                            onClick={() => handleSelect(option[optionValueKey])}
                        >
                            {option[optionLabelKey]}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default CustomSelect

